import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faEdit } from '@fortawesome/free-solid-svg-icons';
import WorkflowDiagram from './WorkflowDiagram';
import '@medprompt/shared/src/common/modals.css';
import '../WorkflowView.css';
import { StatusBadge } from '@medprompt/shared';

const WorkflowPreviewModal = ({ isOpen, onClose, workflow, onEdit, hasEditPermission, activeUsers, teams }) => {
  const navigate = useNavigate();

  if (!isOpen || !workflow) return null;

  const handleEdit = () => {
    onClose();
    if (onEdit) {
      onEdit(workflow.ruleId);
    } else {
      navigate(`/workflow/${workflow.ruleId}`);
    }
  };

  return (
    <div className="modal-overlay" style={{ zIndex: 1001 }}>
      <div className="modal-container workflow-preview-modal" style={{ 
        maxWidth: '900px', 
        maxHeight: '90vh',
        width: '90vw'
      }}>
        <div className="modal-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <StatusBadge
              label={workflow.isActive ? 'Active' : 'Inactive'}
              colorFamily={workflow.isActive ? 'green' : 'yellow'}
              size="normal"
            />
            <h2>{workflow.name || 'Unnamed Workflow'}</h2>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {hasEditPermission && (
              <button 
                className="header-button header-button-primary"
                onClick={handleEdit}
                title="Edit workflow"
              >
                <FontAwesomeIcon icon={faEdit} /> Edit
              </button>
            )}
            <button className="close-button" onClick={onClose}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
        </div>
        
        <div className="modal-content" style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px'
        }}>
          <WorkflowDiagram workflow={workflow} activeUsers={activeUsers} teams={teams} />
        </div>
      </div>
    </div>
  );
};

export default WorkflowPreviewModal;
